import {
  useMutation,
  useQueryClient,
  DefaultError,
} from "@tanstack/react-query";
import * as API from "aws-amplify/api";
import { operations, Types } from "./duck";

const useMutationRequest = <TData = void, Variables = void>({
  apiName,
  method,
  path = "",
  options,
  onSuccess,
  onError,
  mutationKey,
  invalidateQueries,
}: Types.MutationArgs<TData>) => {
  const queryClient = useQueryClient();

  const mutation = useMutation<TData, DefaultError, Variables>({
    mutationKey,
    onError: (e) => onError?.(e.message),
    onSuccess: async (newData) => {
      if (invalidateQueries) {
        await Promise.all(
          invalidateQueries.map((item) =>
            queryClient.invalidateQueries({
              queryKey: item,
            }),
          ),
        );
      }

      onSuccess?.(newData);
    },
    mutationFn: async (variables) => {
      const operation = API[method]({
        apiName,
        path,
        options: {
          ...options,
          body: (variables as any) || undefined,
        },
      });

      return operations.queryFnWrapper<TData>(operation);
    },
  });

  return {
    ...mutation,
    queryClient,
  } as const;
};

export default useMutationRequest;
